module.exports = __webpack_public_path__ + "img/gs.210cac07.svg";